import { socialService } from '../services/firebase/socialService';
import { notificationService } from '../services/firebase/notificationService';

export const socialHelper = {
  /**
   * Extracts @mentions from text
   */
  extractMentions(text: string): string[] {
    const mentionRegex = /@([a-zA-Z0-9_]{3,30})/g;
    const matches = text.match(mentionRegex);
    if (!matches) return [];
    
    // Remove @ and return unique handles
    return [...new Set(matches.map(m => m.substring(1).toLowerCase()))];
  },

  /**
   * Processes mentions in a post or comment
   */
  async processMentions(
    text: string, 
    fromUserId: string, 
    fromUserHandle: string, 
    fromUserName: string,
    targetId: string,
    targetType: 'post',
    fromUserAvatar?: string
  ): Promise<void> {
    const handles = this.extractMentions(text);
    if (handles.length === 0) return;

    for (const handle of handles) {
      // Don't notify yourself
      if (handle === fromUserHandle.toLowerCase()) continue;

      try {
        const profile = await socialService.getProfileByHandle(handle);
        if (profile && profile.userId) {
          await notificationService.createNotification(profile.userId, {
            type: 'comment', // Using 'comment' type for mentions or we could add 'mention'
            fromUserId,
            fromUserHandle,
            fromUserName,
            fromUserAvatar,
            targetId,
            targetType,
            message: `mencionou você em um ${targetType === 'post' ? 'post' : 'comentário'}.`
          });
        }
      } catch (error) {
        console.error(`Error processing mention for ${handle}:`, error);
      }
    }
  }
};
